import React from "react";

export default function MlToOdoo() {
  return <div>ml to odoo</div>;
}
